import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../../routing/getFlowKey';
const MARKETING_PRODUCTISED_FLOWS = [Flow.Marketing];
export const isMarketingProductisedFlow = () => MARKETING_PRODUCTISED_FLOWS.includes(getFlowKey());